import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, useEffect } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { SOLUTION_STORE_SEARCH_COMPLETED } from "/constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import SearchIcon from "monday-ui-react-core/dist/icons/Search";
import CloseSmall from "monday-ui-react-core/dist/icons/CloseSmall";
import dynamic from "next/dynamic";
import MenuComponent from "./menu-component/menu-component";
import { StyledTemplatesNavigation } from "./navigation-component.scss";
const Search = dynamic(()=>import("monday-ui-react-core/dist/Search"), {
    ssr: false
});
const TemplatesNavigation = (props)=>{
    const { onSearchChange, searchTerm, translate, allCategories, selectedCategoryId } = props;
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(()=>{
        setIsLoaded(true);
    }, []);
    const onSearchBlur = useCallback((e)=>{
        var _e_target;
        trackEvent(SOLUTION_STORE_SEARCH_COMPLETED, {
            kind: e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value
        });
    }, []);
    return /*#__PURE__*/ _jsx(StyledTemplatesNavigation, {
        className: "navigation-component",
        children: isLoaded && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "search-wrapper",
                    children: /*#__PURE__*/ _jsx(Search, {
                        placeholder: translate("templateCenter.template.search"),
                        onChange: onSearchChange,
                        value: searchTerm,
                        iconName: SearchIcon,
                        secondaryIconName: CloseSmall,
                        onBlur: onSearchBlur
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "category-list-wrapper",
                    children: /*#__PURE__*/ _jsx(MenuComponent, {
                        allCategories: allCategories,
                        selectedCategoryId: selectedCategoryId
                    })
                })
            ]
        })
    });
};
TemplatesNavigation.defaultProps = {
    onSearchChange: ()=>{}
};
export default withGenericConfig(TemplatesNavigation);
